<script setup lang="ts">
import type { ProgressProps } from '#ui/components/Progress.vue'

type Size = 'md' | '2xs' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl'
type Animation = 'carousel' | 'carousel-inverse' | 'swing' | 'elastic'

export interface VProgressProps {
  value?: number
  max?: number
  size?: Size
  animation?: Animation
  status?: boolean
  ui?: ProgressProps['ui']
}

const props = withDefaults(defineProps<VProgressProps>(), {
  value: undefined,
  max: 100,
  size: 'xl',
  animation: undefined,
  ui: undefined
})

const computedUi = computed<ProgressProps['ui']>(() =>
  nuxtUiMerge(props.ui, {
    indicator: tw`bg-primary dark:bg-success`
  })
)
</script>

<template>
  <UProgress :model-value="value" :max :size :animation :status :ui="computedUi">
    <template v-if="$slots['status']" #status="{ percent }">
      <slot name="status" :percent="percent" />
    </template>
  </UProgress>
</template>

<style scoped></style>
